import React from 'react'
import InputSearch from '../InputSearch/InputSearch';
import './styles.scss';
const Buscador = () => {
    return (
			<section className="bgTitle bgTienda bgTienda--home py-5">
				<div className="container">
					<div className="row">
						<div className="col-12 col-md-6">
							<h2>COMPRA DESDE TU CASA!</h2>
							<h3>¿Qué estás buscando?</h3>
							<InputSearch></InputSearch>
						</div>
					</div>
				</div>
			</section>
    )
}

export default Buscador
